import { useEffect, useState } from "react";
import { Plus, Pencil, Trash2, Check, X } from "lucide-react";
import { toast } from "sonner";
import { PageHeader } from "@/components/PageHeader";
import { CategoryIcon } from "@/components/CategoryIcon";
import { api, errorMessage } from "@/lib/api";

export default function Categories() {
  const [cats, setCats] = useState([]);
  const [name, setName] = useState("");
  const [editing, setEditing] = useState(null);
  const load = () => api.get("/categories").then((r) => setCats(r.data));
  useEffect(() => { load(); }, []);

  const create = async (e) => {
    e.preventDefault();
    try { await api.post("/categories", { name }); setName(""); toast.success("Categoria criada."); load(); } catch (err) { toast.error(errorMessage(err)); }
  };
  const rename = async (c) => {
    try { await api.put(`/categories/${c.id}`, { name: editing.name }); setEditing(null); toast.success("Categoria atualizada."); load(); } catch (err) { toast.error(errorMessage(err)); }
  };
  const remove = async (c) => { await api.delete(`/categories/${c.id}`); toast.success("Categoria removida. Memórias movidas para Outros."); load(); };

  return (
    <div className="pb-10">
      <PageHeader title="Categorias" />
      <div className="ga-fade-up px-5">
        <form onSubmit={create} className="flex gap-2">
          <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Nova categoria" className="ga-input" data-testid="category-name-input" required minLength={2} />
          <button type="submit" className="flex h-[52px] w-[52px] shrink-0 items-center justify-center rounded-2xl text-white" style={{ background: "#13C9A3" }} aria-label="Criar categoria" data-testid="category-create-button"><Plus /></button>
        </form>
        <div className="mt-4 space-y-2" data-testid="categories-list">
          {cats.map((c) => (
            <div key={c.name} className="ga-card flex items-center gap-3 p-3" data-testid={`category-item-${c.name}`}>
              <CategoryIcon category={c.name} size={40} iconSize={18} />
              {editing?.id === c.id && c.id ? (
                <>
                  <input value={editing.name} onChange={(e) => setEditing({ ...editing, name: e.target.value })} className="ga-input flex-1 py-2" data-testid="category-edit-input" />
                  <button onClick={() => rename(c)} className="p-2" style={{ color: "#13C9A3" }} aria-label="Salvar" data-testid="category-edit-save"><Check size={18} /></button>
                  <button onClick={() => setEditing(null)} className="ga-muted p-2" aria-label="Cancelar"><X size={18} /></button>
                </>
              ) : (
                <>
                  <div className="flex-1"><div className="text-sm font-semibold">{c.name}</div><div className="ga-muted text-xs">{c.count} {c.count === 1 ? "memória" : "memórias"}{c.is_default ? " • padrão" : ""}</div></div>
                  {!c.is_default && (<><button onClick={() => setEditing({ id: c.id, name: c.name })} className="ga-muted p-2" aria-label="Editar" data-testid={`category-edit-${c.name}`}><Pencil size={16} /></button><button onClick={() => remove(c)} className="p-2 text-red-400" aria-label="Excluir" data-testid={`category-delete-${c.name}`}><Trash2 size={16} /></button></>)}
                </>
              )}
            </div>
          ))}
        </div>
        <p className="ga-muted mt-4 text-xs">Para alterar a categoria de uma memória, abra a memória e toque em Editar.</p>
      </div>
    </div>
  );
}
